module.exports = __webpack_public_path__ + "obi.png?dff2e124f2d3ae087e1a29423508b7d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/obi.png
// module id = 987
// module chunks = 2